import qs from 'qs';
import { AxiosInstance } from 'axios';
import { CollectionResource } from '@app/data/resources';
import { AvailableCouponFilterInput, SyncCouponInput } from './inputs';
import { AvailableCouponResource, CouponResource, CouponListItemResource } from './resources';
import { CouponRef } from './refs';

export default class Coupon {
    private basePath = '/api/coupon';
    private http: AxiosInstance;

    constructor(http) {
        this.http = http;
    }

    // Force-sync coupon from the external source
    sync = async (input: SyncCouponInput): Promise<CouponRef> => {
        const { data } = await this.http.post(`${this.basePath}/sync`, input);

        return data;
    };

    // Get coupon list
    get = async (): Promise<CollectionResource<CouponListItemResource, {}>> => {
        const { data } = await this.http.get(`${this.basePath}/`);

        return data;
    };

    // Get single coupon
    getById = async (id: ID): Promise<CouponResource> => {
        const { data } = await this.http.get(`${this.basePath}/${id}`);

        return data;
    };

    // Get available coupon
    getAvailable = async (filter: AvailableCouponFilterInput): Promise<AvailableCouponResource> => {
        const query = qs.stringify(filter);

        const { data } = await this.http.get(`${this.basePath}/available?${query}`);

        return data;
    };

    // Get single coupon from external ID
    getByExternalId = async (couponExternalId: string): Promise<CouponResource> => {
        const { data } = await this.http.get(`${this.basePath}/external/${couponExternalId}`);

        return data;
    };
}
